import type { InterventionSectionProviderComponentProps } from "./intervention-section-context.type";

import InterventionSectionDatasetsMutator from "@/modules/intervention/intervention-section-datasets-mutator";

import { InterventionSectionContext } from "./intervention-section-context.context";
import { useInterventionSectionProvider } from "./intervention-section-context.hook";

const InterventionSectionProvider = ({
  children,
  ...props
}: InterventionSectionProviderComponentProps) => {
  const value = useInterventionSectionProvider(props);

  return (
    <InterventionSectionContext.Provider value={value}>
      <InterventionSectionDatasetsMutator />
      {children}
    </InterventionSectionContext.Provider>
  );
};

export default InterventionSectionProvider;
